import React from 'react';
import { useParams, Link } from 'react-router-dom';
import imageData from '../data/imageData';
import './AlbumGallery.css';

const AlbumGallery = () => {
  const { category } = useParams();
  const titleMap = {
    human: 'Portraits',
    nature: 'Nature',
    sky: 'Clouds',
    urban: 'Street Photography'
  };

  const images = imageData.filter(
    img => img.category.toLowerCase() === category.toLowerCase()
  );

  return (
    <div className="album-gallery-page">
      <h1 className="album-title">{titleMap[category.toLowerCase()]}</h1>

      <div className="album-image-grid">
        {images.map((img, i) => (
          <Link key={i} to={`/view?img=${encodeURIComponent(img.src)}`}>
            <img src={img.src} alt={img.alt} loading="lazy" />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AlbumGallery;
